import { ActionIcon, ColorInput, ColorSwatch, Group, Tooltip } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";

interface Props {
  label: string;
  value: string;
  onChange: (value: string) => void;
  suggestedColors?: string[];
  description?: string;
}

export function ColorPickerRow({ label, value, onChange, suggestedColors = [], description }: Props) {
  return (
    <Group w="100%" align="flex-end" gap="sm">
      <ColorInput
        label={label}
        description={description}
        value={value}
        onChange={onChange}
        format="hex"
        style={{ flex: 1 }}
        swatches={["#25262b", "#868e96", "#fa5252", "#e64980", "#be4bdb", "#7950f2", "#4c6ef5", "#228be6", "#15aabf", "#12b886", "#40c057", "#82c91e", "#fab005", "#fd7e14"]}
      />
      {suggestedColors.length > 0 && (
        <Group gap={4} mb={2}>
          {suggestedColors.slice(0, 5).map((color, idx) => (
            <Tooltip key={idx} label={`Логоноос: ${color}`}>
              <ActionIcon variant="subtle" onClick={() => onChange(color)} size="sm">
                <ColorSwatch color={color} size={18} />
              </ActionIcon>
            </Tooltip>
          ))}
        </Group>
      )}
      <Tooltip label="Анхны утга">
        <ActionIcon variant="subtle" onClick={() => onChange("")} mb={2}>
          <IconRefresh size={16} />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
}
